import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/pastDuePerformanceSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { pdcTypeOptions } from "../constants";

export const PdcTypeFilter = () => {
  const dispatch = useDispatch();

  const selected = useSelector((state) => state.pastDuesPerformance.selectedFilters.pdcType);

  return (
    <div className="select-box-no-width">
      <p>Type</p>
      <MultiSelectDropdown
        options={pdcTypeOptions}
        selectedFilters={selected}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updatePdcType(data))}
      />
    </div>
  );
};
